// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { number, string } from 'prop-types'

const ModulationRow = ({ idRoot, modulationSummary, power }) => (
  <tr className={power !== null ? 'active' : 'inactive'}>
    <td
      id={`${idRoot}summary`}
      title={modulationSummary}>
      {modulationSummary}
    </td>
    <td
      id={`${idRoot}power`}
      title={power}>
      {power}
    </td>
  </tr>
)

ModulationRow.propTypes = {
  idRoot: string.isRequired,
  modulationSummary: string.isRequired,
  power: number,
}

export default ModulationRow
